import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { LookupDto, LookupType } from '@siza-staff-care/shared/data';
import { Observable } from 'rxjs';
import { AppStateService } from './app-state.service';

type LookupServiceType = Record<string, never>;

@Injectable({
	providedIn: 'root',
})
export class LookupsService extends ComponentStore<LookupServiceType> {
	constructor(private appState: AppStateService) {
		super({});
	}

	/**
	 * Refreshes the lookups collection for a single type name.
	 * @param typeName
	 * @param entries
	 */
	refreshLookups(typeName: string, entries: LookupDto[]) {
		this.appState.registerLookups([{ typeName, entries }]);
	}

	/**
	 * Replaces an existing Lookup in a collection with a replacement.
	 * @param typeName
	 * @param replacement
	 */
	replaceLookup(typeName: LookupType, replacement: LookupDto) {
		this.appState.replaceLookup(typeName, replacement);
	}

	/**
	 * Gets an observable for a lookup collection.
	 * @param typeName The type name of the lookup collection.
	 * @returns
	 */
	getLookupCollection<TLookup extends LookupDto = LookupDto>(typeName: LookupType): Observable<TLookup[]> {
		return this.appState.getLookupCollection<TLookup>(typeName);
	}

	/**
	 * Synchronously returns an already loaded lookup collection.
	 * @param typeName
	 * @returns
	 */
	getRealisedLookupCollection(typeName: string): LookupDto[] {
		return this.appState.getRealisedLookupCollection(typeName);
	}
}
